<template>
  <div class="app-wrapper" >
    <!--<div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>-->
    <LogoView @handleFeedback="handleFeedback"></LogoView>
     <FeedBack ref="feedback" :dialogFormVisible="dialogFormVisible" @cancleFeedback='cancleFeedback'></FeedBack>
    <!--<sidebar class="sidebar-container"></sidebar>-->
    <div class="main-container">
      <!--<navbar></navbar>-->

      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView, LogoView } from './components'
// import ResizeMixin from './mixin/ResizeHandler'
import FeedBack from '../home/feedback'
export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    LogoView,
    FeedBack
  },
   data(){
    return{
      dialogFormVisible:false
    }
  },
  // mixins: [ResizeMixin],
  watch:{
    /*$route:{
      handler(val,oldval){
        if(val.path == '/devices' || val.path == '/resources'){
          this.isSHOW = false
        }
      },
      // 深度观察监听
      deep: true,
      immediate:true
    }*/
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
      handleFeedback(){
          this.dialogFormVisible=true
        },
      cancleFeedback(){
        this.dialogFormVisible=false
        this.$refs.feedback.resetForm()
      },
    handleClickOutside() {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  /*.main-container{*/
    /*margin-top: 50px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue